<template>
<div class="chapter">
<div class="inner_page">
<p class="toch"><b>Contents</b></p>
<p class="toc"><a href="#/v2/cover">Essays in Humanism</a></p>
<p class="toc1"><span href="#/v3/cover" title="Link target outside of Sample">The Theory of Relativity</span></p>
<p class="toc1"><span href="#/v1/cover" title="Link target outside of Sample">The World As I See It</span></p>
<p class="toc1"><span href="#/biography" title="Link target outside of Sample">A Biography of Albert Einstein</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?76940bb8